import { JsonSchemaForm } from '@react-admin/ra-json-schema-form';
import { JSONSchema7 } from 'json-schema';
import { BooleanInput, Create, Datagrid, DateField, Edit, List, ReferenceField, TabbedForm, TextField, TextInput, WithRecord, useRecordContext } from 'react-admin';
import { defaultListFilters } from './customized-elements';

export const SettingList = () => (
    <List filters={ defaultListFilters }>
        <Datagrid rowClick="edit" isRowSelectable={(record) => false}>
            <TextField source="settingKey" />
            <WithRecord
                render={record => {
                    if (record.settingType === 'json') {
                        record.settingValue = JSON.stringify(record.settingValue)
                    }
                    return (
                        <TextField source="settingValue"
                            textOverflow='ellipsis'
                            style={{
                            maxWidth: 300,
                            maxHeight: 100,
                            overflow: 'auto',
                            display: 'inline-block',
                        }}/>

                    )
                }}
            />
            <ReferenceField source="createdBy" reference="administrators">
                <TextField source="email" />
            </ReferenceField>
            <DateField source="createdAt" />
            <ReferenceField source="updatedBy" reference="administrators">
                <TextField source="email" />
            </ReferenceField>
            <TextField source="updatedAt" />
        </Datagrid>
    </List>
)

const SettingTitle = () => {
    const record = useRecordContext();
    return <span>Setting Code: {record ? `${record?.settingKey}` : ''}</span>;
}

export const SettingEdit = (props: any) => {
    return (
        <Edit title={ <SettingTitle /> }>
            <WithRecord
                render={record => {
                    const jsonSchema: JSONSchema7 = record.jsonSchema || {
                        type: 'object',
                        properties: {
                            settingKey: {
                                type: 'string',
                                title: 'Setting',
                            },
                            settingValue: {
                                type: 'string',
                                title: 'Value',
                            } ,
                        },
                    }
                    const uiSchema = record.uiSchema || {
                        settingKey: {
                            "ui:disabled": true,
                        },
                    }

                    if (record.settingType === 'json') {

                        record.jsonSchemaString = JSON.stringify(jsonSchema)
                        record.uiSchemaString = JSON.stringify(uiSchema)

                        return (
                            <>
                            <TabbedForm >
                                <TabbedForm.Tab label='Detail'>
                                    <TextInput source="id" disabled fullWidth />
                                    <TextInput source="settingKey" disabled fullWidth helperText='This needs to be be unique. Once created, this cannot be changed' />
                                    <TextInput source="description" multiline fullWidth />
                                    <TextInput source="settingType" fullWidth />
                                    <BooleanInput source="status" />
                                </TabbedForm.Tab>

                                <TabbedForm.Tab label='Schema'>
                                    <TextInput source="jsonSchemaString" multiline fullWidth
                                        helperText='Form Schema. Please do not change without backup'
                                    />
                                    <TextInput source="uiSchemaString" multiline fullWidth
                                        helperText='Form UI Schema. Please do not change without backup'
                                    />
                                </TabbedForm.Tab>
                            </TabbedForm>

                            <JsonSchemaForm
                                schema={ jsonSchema }
                                uiSchema={ uiSchema }
                            />
                            </>
                        )
                    }

                    record.jsonSchema = JSON.stringify(jsonSchema)
                    record.uiSchema = JSON.stringify(uiSchema)

                    return (
                        <TabbedForm>
                            <TabbedForm.Tab label='Setting'>
                                <TextInput source="id" disabled fullWidth />
                                <TextInput source="settingKey" disabled fullWidth helperText='This needs to be be unique. Once created, this cannot be changed' />
                                <TextInput source="description" multiline fullWidth />
                                <TextInput source="settingType" fullWidth />
                                <BooleanInput source="status" />
                            </TabbedForm.Tab>

                            <TabbedForm.Tab label='Value'>
                                <TextInput source="settingValue" multiline fullWidth />
                            </TabbedForm.Tab>

                            <TabbedForm.Tab label='Schema'>
                                <TextInput source="jsonSchema" multiline fullWidth />
                                <TextInput source="uiSchema" multiline fullWidth />
                            </TabbedForm.Tab>
                        </TabbedForm>
                    )
                }}
            />
        </Edit>
    );
}

export const SettingCreate = () => {
    return (
        <Create>
            <TabbedForm>
                <TabbedForm.Tab label='Detail'>
                    <TextInput source="settingKey" fullWidth helperText='This needs to be be unique. Once created, this cannot be changed' />
                    <TextInput source="settingValue" multiline fullWidth />
                    <TextInput source="description" multiline fullWidth />
                    <BooleanInput source="status" defaultValue={ true }/>
                </TabbedForm.Tab>
                <TabbedForm.Tab label='Setting Type'>
                    <TextInput source="settingType" multiline fullWidth />
                    <TextInput source="jsonSchema" multiline fullWidth />
                    <TextInput source="uiSchema" multiline fullWidth />
                </TabbedForm.Tab>
            </TabbedForm>
        </Create>
    );
}